export default "__VITE_ASSET__Dmewlh8Q__"